import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHead, Loading, BrandDot } from "@/components/common";

export default function Feedback() {
  const { selectedBrand } = useApp();
  const [data, setData] = useState(null);
  useEffect(() => { const b = selectedBrand === "ALL" ? "" : `?brand=${selectedBrand}`; api.get(`/feedback/responses${b}`).then((r) => setData(r.data)); }, [selectedBrand]);
  if (!data) return <Loading />;
  const max = Math.max(1, ...Object.values(data.distribution));

  return (
    <div>
      <PageHead overline="Feedback Manager" title="Feedback & NPS" desc="Optional feedback never withholds an earned reward. Low ratings auto-create support cases." />
      <div className="grid lg:grid-cols-3 gap-6 mb-6">
        <div className="bg-white rounded-xl border border-slate-200 p-5 text-center">
          <div className="text-5xl font-bold text-violet-600 font-head">{data.average || "—"}</div>
          <div className="text-sm text-slate-400 mt-1">Average rating · {data.count} responses</div>
        </div>
        <div className="lg:col-span-2 bg-white rounded-xl border border-slate-200 p-5">
          <h3 className="font-semibold text-slate-800 mb-3 font-head">Rating distribution</h3>
          {[5, 4, 3, 2, 1].map((r) => (
            <div key={r} className="flex items-center gap-3 mb-2 text-sm">
              <span className="w-8 text-slate-500">{r}★</span>
              <div className="flex-1 bg-slate-100 rounded-full h-3 overflow-hidden"><div className="h-full tnp-gradient" style={{ width: `${(data.distribution[r] / max) * 100}%` }} /></div>
              <span className="w-8 text-right text-slate-400">{data.distribution[r]}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider"><tr><th className="text-left px-4 py-3">Rating</th><th className="text-left px-4 py-3">Brand</th><th className="text-left px-4 py-3">Comment</th><th className="text-left px-4 py-3">Touchpoint</th><th className="text-left px-4 py-3">Date</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {data.responses.map((r) => (
              <tr key={r.id}><td className="px-4 py-3 font-semibold text-amber-500">{"★".repeat(r.rating)}</td><td className="px-4 py-3"><BrandDot id={r.brand_id} />{r.brand_id}</td><td className="px-4 py-3 text-slate-600">{r.comment || "—"}</td><td className="px-4 py-3 text-slate-400 text-xs">{r.touchpoint}</td><td className="px-4 py-3 text-slate-400 text-xs">{r.at?.slice(0, 10)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
